import {http_client} from "@/plugins/http_client";

const login = async (body) => await http_client('/api/v1/login', body, 'post');
const changeEmail = async (body) => await http_client(`/api/v1/users/update/email`, body, 'put');
const changePassword = async (body) => await http_client(`/api/v1/users/update/password`, body, 'put');
const verifyAccount = async (token) => await http_client(`/api/v1/verification/account/${token}`);
const twoFactor = async (body) => await http_client('/api/v1/2fa/code', body, 'post');
const verifyCode = async (body) => await http_client('/api/v1/2fa/verify', body, 'post');
const get2FAMethods = async () => await http_client('/api/v1/users/2fa/method');
const store2FAMethods = async (body) => await http_client('/api/v1/users/2fa/method', body, 'post');
const authMethodVerification = async (body) => await http_client('/api/v1/users/2fa/method/verify', body, 'post');
const changePrimaryMethod = async (idMethod) => await http_client(`/api/v1/users/2fa/method/${idMethod}`, {}, 'put');
//const logout = async () => await http_client('/api/v1/logout', {}, 'post')
const logout = async (token, tokenIdentidad) => await http_client('api/logout', { identidad_token: tokenIdentidad },'post', { Authorization: `Bearer ${token}` });
const resetPassword = async (body) => await http_client('/api/v1/password/reset', body, 'post')
const newPassword=async (body, token)=>await http_client('/api/v1/password/change', body, 'put', {
    Authorization: `Bearer ${token}`,
});
const verificarUsuario = async (params = {}, token) => await http_client('/api/v1/verificar-usuario-perfil', params, 'get', {
    Authorization: `Bearer ${token}`,
});
const seleccionarPuesto = async (body) => await http_client('/api/v1/seleccionar-puesto', body, 'post');

const obtenerModulos = async (body) => await http_client('/api/modulos-app', body, 'get');

const obtenerModuloPrincipal = async (body) => await http_client('/api/url-modulo', body, 'get');

// Generar token con session_uuid
const obtenerSesionPorUUID = async (session_uuid) => await http_client(`/api/session`, {session_uuid}, 'get');

// Obtener foto de persona
const getFotoPersona = async (id_persona) => await http_client(`${process.env.VUE_APP_URL_API_BOLSA_EMPLEO}/api/v1/documento/persona/get-foto/${id_persona}`);

const getInfoInstitucion = async () => await http_client(`/api/institucion-configuracion-logo`);
const getInstitucionLogo = async(params={}) => await http_client(`/api/institucion-logo`, params)
const postInstitucionLogo = async (body) => await http_client('/api/institucion-logo/actualizar', body, 'post')

export default {
    login,
    changeEmail,
    changePassword,
    verifyAccount,
    verifyCode,
    twoFactor,
    get2FAMethods,
    store2FAMethods,
    authMethodVerification,
    changePrimaryMethod,
    logout,
    resetPassword,
    newPassword,
    verificarUsuario,
    seleccionarPuesto,
    obtenerModulos,
    obtenerModuloPrincipal,
    obtenerSesionPorUUID,
    getFotoPersona,
    getInstitucionLogo,
    postInstitucionLogo,
    getInfoInstitucion
}